<ng-container *ngIf="userresponsestatus == true; else noListItemTmpl">

  <div class="outer_div">
    <div class="mainsec">


      <div class="content">


        <img src="../../../../assets/Images/tick.png" class="timeicon" />
        <span>
          Transaction Success

        </span>

        <div class="amount">
          <label>Your Promo Code : {{Voucher}}  <button class="btn btn-success btn-block" (click)="onCopy(Voucher)">Copy Promo Code</button></label> <br />


          <span>Invoice No. : {{invoiceno}}</span>
          <label>
            Congratulations your course has been delivered to your registered email I'd along with the invoice.&nbsp;

            !!! You won a promo code to get a next free course of same amount <b>( can only be redeem on www.Iripas.com)</b>
          </label>

          <div class="amount">
            <a href="http://35.85.177.202:9097/#/Go-on">Back To Home</a>
          </div>
        </div>



      </div>

    </div>
  </div>


</ng-container>

<ng-template #noListItemTmpl>
  <div class="outer_div">


    <div class="mainsec" *ngIf="Voucher == undefined">

      <div>
        <img src="../../../../assets/Images/error.png" class="timeicon" />
      </div>

      <div class="amount">

        <span>{{message}}</span>
      </div>
      <div class="amount">
        <a href="http://35.85.177.202:9097/#/Go-on">Back To Home</a>
      </div>
    </div>

    <div class="mainsec" *ngIf="Voucher != undefined">

      <div>
        <img src="../../../../assets/Images/process.png" class="timeicon" />
      </div>

      <div class="amount">
        <span>Your Promo Code is in-process </span>  <br />

        <span>Invoice No. : {{invoiceno}}</span>
      </div>
      <div class="amount">
        <a href="http://35.85.177.202:9097/#/Go-on">Back To Home</a>
      </div>
    </div>


  </div>

</ng-template>




<style>
  .outer_div {
    border-style: solid;
    /*margin-right: 100px;
        position: absolute;*/
  }

  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*display: flex;
        justify-content: center;
        align-items: center;*/
  }

  .mainsec {
    border: 1px solid #e5dfdf;
    text-align: center;
    margin: auto;
    border-radius: 30px;
  }

  .logo {
    width: 210px;
    padding: 20px 0;
  }

  .amount {
    font-size: 25px;
    padding: 10px 0;
  }

  .timeicon {
    width: 100px;
    height: 100px;
    margin: 20px 0;
  }

  .msg {
    font-size: 30px;
    padding: 10px 0;
    color: gray;
    font-size: 20px;
  }

  .amountt {
    font-size: 30px;
    padding: 10px 0;
    color: steelblue;
  }
</style>



